import * as actionTypes from '../consts/actionTypes';

export function getActivities(param = '') {
    return {
        type: actionTypes.GET_ALL_ACTIVITIES,
        payload: param
    };
}